module.exports = __webpack_public_path__ + "res/MaterialIcons-Regular.woff2";


//////////////////
// WEBPACK FOOTER
// ./client/app/vendor/googlefonts/MaterialIcons-Regular.woff2
// module id = 94
// module chunks = 1